import React from "react";

// Clsx
import clsx from "clsx";

// Lib
import { Link } from "react-router-dom";

// components
import Img from "components/Img";
import Button from "components/UiKit/Button";

const DownloadSDF: React.FC<any> = (props) => {
	const { modalProps, actions } = props;
	const {
		title,
		innerClass,
		actionSubmit,
	} = modalProps;

	const cn = clsx(
		"download-sdf flex flex-direction-column flex-ai-center flex-jc-center",
		innerClass ? innerClass : ""
	);

	const handleSubmit = (type: string) => {
		actionSubmit && actionSubmit(type);

		actions.closeCallback();
	};

	return (
		<div className={cn}>
			<h4 className="download-sdf__title mb30">{title}</h4>
			<div className="flex flex-ai-center">
				<Button
					label="V2000"
					variable="info"
					typePadding="small"
					onPress={() => handleSubmit('V2000')}
				/>
				<p className="download-sdf__or mr10 ml10">or</p>
				<Button
					label="V3000"
					variable="info"
					typePadding="small"
					onPress={() => handleSubmit('V3000')}
				/>
			</div>
		</div>
	);
};

export default DownloadSDF;
